/**
 * Subscription Details Screen
 * Dedicated screen for viewing and managing subscriptions from Settings
 */

import React, {useCallback, useEffect} from 'react';
import {View, ScrollView} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {useTheme} from '~contexts/ThemeContext';
import ModernHeader from '~components/ModernHeader/ModernHeader';
import {SubscriptionsView} from '~components/Subscription';
import {SubscriptionPlan, SubscriptionType} from '~types/subscription/subscription.types';
import {logScreenView} from '~Utils/firebaseAnalytics';
import {useGetActivePlan} from '~hooks/subscription/useGetActivePlan';

/**
 * Subscription Details Screen - shown when user clicks subscription card in settings
 */
const SubscriptionDetailsScreen = () => {
  const navigation = useNavigation();
  const {colors} = useTheme();
  const {data: activePlan} = useGetActivePlan();

  useEffect(() => {
    logScreenView('SubscriptionDetails', 'SubscriptionDetailsScreen');
  }, []);

  const handleSubscriptionSelect = useCallback(
    (planId: SubscriptionPlan, type: SubscriptionType) => {
      console.log('Subscription selected:', planId, type);
      // TODO: Process subscription upgrade/change
      // Navigate back after selection
       setTimeout(() => {
      navigation.goBack();
      }, 600);
    },
    [navigation],
  );

  return (
    <SafeAreaView edges={['top']} style={{flex: 1, backgroundColor: colors.background}}>
      <View style={{flex: 1, backgroundColor: colors.background}}>
        <SubscriptionsView
          isCheckoutFlow={false}
          showHeader={true}
          onSubscriptionSelect={handleSubscriptionSelect}
          currentPlanId={activePlan?.plan_id as SubscriptionPlan}
        />
      </View>
    </SafeAreaView>
  );
};

export default SubscriptionDetailsScreen;
